import { CSSProperties, ReactNode } from 'react';
import { AlertProps } from '@mui/material';
import {
  custom2,
  error,
  info,
  secondary,
  success,
  normalText,
} from 'assets/colors/colors';
import {
  CheckIcon,
  ErrorOutlineIcon,
  InfoOutlinedIcon,
  ReportProblemOutlinedIcon,
} from 'assets/icons';

export const getAlertStyles: Record<
  Exclude<AlertProps['severity'], undefined>,
  CSSProperties
> = {
  success: {
    backgroundColor: success.background,
    color: success.main,
  },
  warning: {
    backgroundColor: secondary.background,
    color: normalText.main,
    border: `1px solid ${custom2.main}`,
  },
  error: {
    backgroundColor: error.background,
    color: error.main,
  },
  info: {
    backgroundColor: info.background,
    color: info.main,
  },
};

export const getInfoIcon: Record<
  Exclude<AlertProps['severity'], undefined>,
  ReactNode
> = {
  success: <CheckIcon sx={{ color: success.main }} />,
  warning: <ReportProblemOutlinedIcon sx={{ color: custom2.main2 }} />,
  error: <ErrorOutlineIcon sx={{ color: error.main }} />,
  info: <InfoOutlinedIcon sx={{ color: info.main }} />,
};
